import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsNumberCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}:host{display:block}:host .number-content{display:flex;align-items:center}:host fds-input{margin-bottom:0}:host input.number-input{min-width:48px}:host .fds-label{display:inline-block;margin-bottom:0.25rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:bold;font-size:1rem;line-height:1.5;letter-spacing:0;margin-bottom:0.75rem}";

const FdsNumber = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.setValue = createEvent(this, "setValue", 7);
    this.label = undefined;
    this.value = undefined;
    this.min = undefined;
    this.max = undefined;
    this.width = 48;
    this.localValue = undefined;
  }
  validateValue(newValue) {
    if (newValue < this.min) {
      this.localValue = this.min;
    }
    else if (newValue > this.max) {
      this.localValue = this.max;
    }
    this.updateWidth();
    this.setValue.emit(this.localValue);
  }
  componentDidLoad() {
    this.localValue = this.value;
    this.ensureValueWithinRange();
    this.updateWidth();
  }
  ensureValueWithinRange() {
    if (this.localValue < this.min) {
      this.localValue = this.min;
    }
    else if (this.localValue > this.max) {
      this.localValue = this.max;
    }
    this.setValue.emit(this.localValue);
  }
  handleSubtract() {
    if (this.localValue > this.min) {
      this.localValue = this.localValue - 1;
    }
  }
  handleAdd() {
    if (this.localValue < this.max) {
      this.localValue = this.localValue + 1;
    }
  }
  handleInput(e) {
    const inputElement = e.target;
    const newValue = parseInt(inputElement.value, 10);
    if (inputElement.value === '') {
      // Allow empty string but don't update localValue
      inputElement.style.width = '48px'; // Reset width to default when input is empty
    }
    else if (!isNaN(newValue)) {
      this.localValue = newValue;
    }
    else {
      inputElement.value = this.localValue.toString(); // Reset input to current localValue if input is invalid
    }
  }
  handleKeydown(e) {
    const key = e.key;
    // Allow backspace, delete, tab, escape, enter, and navigation keys
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'].indexOf(key) !== -1 ||
      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (key === 'a' && e.ctrlKey === true) ||
      (key === 'c' && e.ctrlKey === true) ||
      (key === 'v' && e.ctrlKey === true) ||
      (key === 'x' && e.ctrlKey === true) ||
      // Allow: home, end, left, right, down, up
      (['Home', 'End'].indexOf(key) !== -1)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress if not
    if ((key < '0' || key > '9') && (key < 'Numpad0' || key > 'Numpad9')) {
      e.preventDefault();
    }
  }
  handleBlur(e) {
    const inputElement = e.target;
    if (inputElement.value === '') {
      this.localValue = this.min;
    }
    inputElement.value = this.localValue.toString();
    this.updateWidth();
  }
  updateWidth() {
    const valueLength = this.localValue.toString().length;
    this.width = Math.max(48, valueLength * 18); // Adjust the multiplier as needed
  }
  render() {
    return (h(Host, null, h("div", { class: "fds-label" }, this.label), h("div", { class: "number-content" }, h("fds-icon-button", { icon: "subtractCircle", color: "blue", size: 24, onClick: () => this.handleSubtract() }), h("fds-input", { "invalid-message": "Fix error" }, h("input", { type: "text", id: "number-input", min: this.min, max: this.max, class: "number-input", value: this.localValue, onInput: (e) => this.handleInput(e), onKeyDown: (e) => this.handleKeydown(e), onBlur: (e) => this.handleBlur(e), style: { width: `${this.width}px` } })), h("fds-icon-button", { icon: "addCircle", color: "blue", size: 24, onClick: () => this.handleAdd() }))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "localValue": ["validateValue"]
  }; }
};
FdsNumber.style = fdsNumberCss;

export { FdsNumber as fds_number };
